<div class="slider">
  <splide [options]="sliderOptions" class="slider slider--pink">
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/bingoals-now/slide1.svg" alt="Slide 1" class="m-auto">
        </div>
        <div class="slider__desc">
          Your <strong>15 coins</strong> relate to <strong>15 teams</strong> out of all those that are playing on this date.
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/bingoals-now/slide2.svg" alt="Slide 2" class="m-auto">
        </div>
        <div class="slider__desc">
          <strong>If a team scores</strong> that you have on your card, that <strong>coin turns purple.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/bingoals-now/slide3.svg" alt="Slide 3" class="m-auto">
        </div>
        <div class="slider__desc">
          If you’re <strong>first to get 1 and/or 2 Lines</strong>, you <strong>win a prize.</strong>
        </div>
      </div>
    </splide-slide>
    <splide-slide>
      <div class="slider__item pb-10">
        <div class="slider__img">
          <img src="/images/tutorial/game/slides/bingoals-now/slide4.svg" alt="Slide 4" class="m-auto">
        </div>
        <div class="slider__desc">
          If <strong>all your 15 events happen first</strong> in the match, you <strong>get a Full House</strong>, <br /> and you <strong>win the main prizepot.</strong>
        </div>
      </div>
    </splide-slide>
  </splide>
</div>
